import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./Sidebar";
import "../assets/css/button.css";
import "../assets/css/candidate-thank-you.css";
import TickGreenBigIcon from "../assets/img/tick-green-big-icon.svg";
import CustomRatingRadio from "./CustomRatingRadio";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getLogout } from "../Actions/logoutAction";
import _ from "lodash";
import { saveFeedback } from "../Actions/feedbackAction";
import Loader from "./Common/loader";

const CandidateThankYou = (props) => {
  const navigate = useNavigate();
  const storeLogoutData = useSelector((state) => state.logout);
  const dispatch = useDispatch();
  const { logoutData } = storeLogoutData;
  const [feedbackComment, setFeedbackComment] = useState([]);
  const [otherDetail, setOtherDetail] = useState("");
  const [starRating, setStarRating] = useState();
  const [textBox, setTextextBox] = useState(0);
  const [clientId, setClientId] = useState('')

  const storeFeedbackData = useSelector((state) => state.feedbackSave);
  const { feedbackSaveData, error: saveError } = storeFeedbackData;
  console.log(feedbackSaveData);

  useEffect(()=>{
    let user = JSON.parse(localStorage.getItem('userVerificationCandidate'));
    let Id;
    
    if(user && (user?.client_id || user?.bridge_client_id)){
      Id = user?.client_id || user?.bridge_client_id; 
      setClientId(Id);
    }
  },[])


  useEffect(() => {
    console.log(feedbackSaveData);
    if (
      typeof feedbackSaveData?.code !== "undefined" &&
      feedbackSaveData?.code !== null
    ) {
      logoutHandler();
    }
  }, [storeFeedbackData, feedbackSaveData]);

  //console.log(data);
  //console.log(feedbackSaveData);
  // useEffect(()=>{
  //   if (typeof logoutData !== "undefined" && logoutData !== null) {
  //     if (logoutData.status === "success") {
  //       window.location.href = 'login';
  //     }
  //   }
  // },[storeLogoutData]);

  const logoutHandler = () => {
    dispatch(getLogout());
    // setTimeout(() => {
    //   dispatch(getLogout())
    // }, 5000)
  };
  //logoutHandler();
  

  const handleChange = (e) => {
    let checked = e.target.checked;
    let checkId = e.target.id;
    if (e.target.id == "other") {
      setTextextBox(1);
    }
    if (checked) {
      setFeedbackComment((PrevFeedbackComment) => {
        return [...feedbackComment, checkId];
      });
    }
    console.log(checked);

    if (!checked) {
      if (e.target.id == "other") {
        setTextextBox(0);
      }
      for (var i = 0; i < feedbackComment.length; i++) {
        if (feedbackComment[i] == checkId) {
          feedbackComment.splice(i, 1);
        }
      }
    }

    console.log(feedbackComment);
  };

  const handleChangeOther = (e) => {
    setOtherDetail(e.target.value);
  };

  let record = [];
  const setRating = (rating) => {
    //record[1]=[];
    console.log(feedbackComment);
    for (var i = 0; i < feedbackComment.length; i++) {
      console.log(document.getElementById(feedbackComment[i]));
      document.getElementById(feedbackComment[i]).checked = false;
    }
    setFeedbackComment([]);
    setOtherDetail("");
    setTextextBox(0);
    console.log(feedbackComment);
    console.log(rating);
    setStarRating(parseInt(rating));
  };

  const logoutHandler2 = () => {
    console.log(starRating);
    dispatch(saveFeedback(record));
    logoutHandler();
    //dispatch(getLogout());
    // setTimeout(() => {
    //   dispatch(getLogout())
    // }, 5000)
  };

  //if(flag!=0){
  console.log("Hi" + starRating);
  record = [starRating, feedbackComment, otherDetail];
  console.log(record);
  console.log(typeof record[0]);
  console.log(record[1]);
  console.log(typeof record[2]);

  // const handleSubmit=()=>{

  //   dispatch(saveFeedback(record));
  // }

  return (
    <>
      {/* {isLoading ?
      <Loader /> :
      <> */}
      <Header />
      <Sidebar />
      <div className="d-flex align-items-center justify-content-center">
        <section className="main-section h-100 thank-you-page">
          <div className="container">
            <div className="row my-5">
              <div className="col-md-12 text-center">
                <img src={TickGreenBigIcon} alt="" width="70" />
                <h3 className="fnt-smi-bld my-2" style={{ fontSize: clientId == 459831 ? '80px' : ''}}>Thank you</h3>
                <p className="text-muted my-2" style={{fontSize:  clientId == 459831 ? 'large' : ''}}>
                  { clientId != 459831 ? 'Your submission has been recieved successfully!' :
                  'You have successfully submitted your profile'}
                </p>
              </div>
            </div>

            <div className="row my-5">
              <div className="col-md-12 text-center my-5">
                <h5 className="fnt-smi-bld">Rate your experience</h5>
                <p className="text-muted my-2">
                  How was your entire form submission journey
                </p>
              </div>
            </div>

            <div className="row my-5">
              <div className="col-md-12 text-center">
                <CustomRatingRadio
                  name="rating"
                  id="1"
                  text="1"
                  setRating={setRating}
                  isActive={starRating >= 1 ? true : false}
                />
                <CustomRatingRadio
                  name="rating"
                  id="2"
                  text="2"
                  setRating={setRating}
                  isActive={starRating >= 2 ? true : false}
                />
                <CustomRatingRadio
                  name="rating"
                  id="3"
                  text="3"
                  setRating={setRating}
                  isActive={starRating >= 3 ? true : false}
                />
                <CustomRatingRadio
                  name="rating"
                  id="4"
                  text="4"
                  setRating={setRating}
                  isActive={starRating >= 4 ? true : false}
                />
                <CustomRatingRadio
                  name="rating"
                  id="5"
                  text="5"
                  setRating={setRating}
                  isActive={starRating >= 5 ? true : false}
                />
                <CustomRatingRadio
                  name="rating"
                  id="6"
                  text="6"
                  setRating={setRating}
                  isActive={starRating >= 6 ? true : false}
                />
                <CustomRatingRadio
                  name="rating"
                  id="7"
                  text="7"
                  setRating={setRating}
                  isActive={starRating >= 7 ? true : false}
                />
                <CustomRatingRadio
                  name="rating"
                  id="8"
                  text="8"
                  setRating={setRating}
                  isActive={starRating >= 8 ? true : false}
                />
                <CustomRatingRadio
                  name="rating"
                  id="9"
                  text="9"
                  setRating={setRating}
                  isActive={starRating >= 9 ? true : false}
                />
                <CustomRatingRadio
                  name="rating"
                  id="10"
                  text="10"
                  setRating={setRating}
                  isActive={starRating >= 10 ? true : false}
                />
              </div>
            </div>
            {starRating <= 8 ? (
              <div className="row my-5">
                <div className="col-md-12 text-center">
                  <div className="common-white-box thank-you-box d-inline-block p-4 text-left">
                    <h5 className="fnt-smi-bld">What went wrong</h5>

                    <div className="form-check mb-1">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="candidateForm"
                        style={{ marginTop: "6px" }}
                        onChange={handleChange}
                      />
                      <label
                        htmlFor="candidateForm"
                        className="form-check-label"
                      >
                        Candidate Form
                      </label>
                    </div>
                    <div className="form-check mb-1">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="slowPageLoad"
                        style={{ marginTop: "6px" }}
                        onChange={handleChange}
                      />
                      <label
                        htmlFor="slowPageLoad"
                        className="form-check-label"
                      >
                        Slow Page loading
                      </label>
                    </div>
                    <div className="form-check mb-1">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="instructionNotClear"
                        style={{ marginTop: "6px" }}
                        onChange={handleChange}
                      />
                      <label
                        htmlFor="instructionNotClear"
                        className="form-check-label"
                      >
                        Instructions not clear
                      </label>
                    </div>
                    <div className="form-check mb-1">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="mobileFormFilling"
                        style={{ marginTop: "6px" }}
                        onChange={handleChange}
                      />
                      <label
                        htmlFor="mobileFormFilling"
                        className="form-check-label"
                      >
                        Mobile Form filling
                      </label>
                    </div>
                    <div className="form-check mb-1">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="other"
                        style={{ marginTop: "6px" }}
                        onChange={handleChange}
                      />
                      <label htmlFor="other" className="form-check-label">
                        Other
                      </label>
                    </div>

                    {textBox == 1 ? (
                      <textarea
                        name=""
                        id=""
                        rows="2"
                        className="form-control mt-3"
                        placeholder="Add Comment"
                        onChange={handleChangeOther}
                      ></textarea>
                    ) : (
                      ""
                    )}

                    <div className="text-right">
                      {/* <a  className="btn-link text-primary mt-3 float-right cursor-pointer" onClick={handleSubmit}>Submit</a>
                  <button onClick={handleSubmit}>Submit</button>  */}
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}

            <div className="row mt-4">
              <div className="col-md-12 text-center mb-4">
                <div className="d-flex justify-content-center flex-column-mbl">
                  {/* <button className="btn btn-primary btn-lg mr-2 btn-block-mbl mb-1-mbl">Back to Home</button> */}
                  <button
                    className="btn btn-outline-secondary btn-lg mr-2 btn-block-mbl"
                    onClick={logoutHandler2}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      </>
    //   }
    // </>
  );
};
export default CandidateThankYou;
